const state = {
  modulosPerfisLiberados: {
    categorias: [],
    ferramentas: [],
    ferramentas_liberadas: [],
    tabelas_liberadas: [],
    conformidades_obras_testes_liberados: []
  },
  loading: false
};
  
const getters = {
  getLoading: state => state.loading,
  getModulosPerfisLiberados: state => state.modulosPerfisLiberados
};
  
const actions = {
  setModulosPerfisLiberados ({ commit }, value) {
    commit('SET_MODULOS_PERFIS_LIBERADOS', value);
  },
  setLoading ({ commit }, value) {
    commit('SET_LOADING', value);
  }
};
  
const mutations = {
  SET_MODULOS_PERFIS_LIBERADOS: (state, value) => (state.modulosPerfisLiberados = value),
  SET_LOADING: (state, value) => (state.loading = value)
};
  
export default {
  state,
  getters,
  actions,
  mutations
};